/**
 * Telemetria de falhas contornadas por fallback (doc 04, A5.1).
 *
 * Um fallback que só faz console.warn é invisível: foi assim que 7 caminhos
 * quebrados passaram meses em produção. registrarFalha() mantém o aviso no
 * console e envia o evento para POST /v1/telemetria/falhas, que grava no log do
 * auth-service (grep FALHA_FRONT).
 *
 * Nunca lança erro nem atrasa a tela: telemetria que falha é descartada.
 */
import { apiConfig, getAuthToken, getTenantSubdomain } from "../config/api";

const JANELA_DEDUPLICACAO_MS = 5 * 60 * 1000;
const MAXIMO_POR_SESSAO = 20;

const ultimoEnvio = new Map();
let enviadosNaSessao = 0;

function mensagemDo(erro) {
  if (!erro) return "";
  if (typeof erro === "string") return erro;
  return String(erro.message || erro.detail || erro.statusText || erro).slice(0, 500);
}

/**
 * @param {string} origem  identificador estável do ponto de falha, ex.: "dashboards.alunos_por_nucleo"
 * @param {unknown} erro   o erro capturado no catch
 */
export function registrarFalha(origem, erro) {
  // eslint-disable-next-line no-console
  console.warn(`[falha contornada] ${origem}:`, erro);

  try {
    const mensagem = mensagemDo(erro);
    const chave = `${origem}|${mensagem}`;
    const agora = Date.now();
    if (agora - (ultimoEnvio.get(chave) || 0) < JANELA_DEDUPLICACAO_MS) return;
    if (enviadosNaSessao >= MAXIMO_POR_SESSAO) return;

    const token = getAuthToken();
    if (!token) return; // sem sessão, o backend recusaria (401)

    ultimoEnvio.set(chave, agora);
    enviadosNaSessao += 1;

    const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };
    const subdominio = getTenantSubdomain();
    if (subdominio) headers["X-Tenant-Subdomain"] = subdominio;

    // fetch direto: o cliente da API tenta refresh e pode deslogar num 401 —
    // um envio de telemetria nunca pode causar isso.
    fetch(`${apiConfig.apiService.baseURL}/v1/telemetria/falhas`, {
      method: "POST",
      headers,
      keepalive: true,
      body: JSON.stringify({ origem, mensagem, rota: window.location.pathname.slice(0, 300) }),
    }).catch(() => {});
  } catch {
    // Telemetria nunca derruba a tela.
  }
}
